export const environment = {
    production: false,
    hmr       : false,
    API_URL:'https://gr-api.tectrain.com.br/'
  };
